// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"06ad4f75","232":"484eca45","406":"70dc7157","900":"8067c7c3"}[chunkId] + ".chunk.css";
};